import { render, staticRenderFns } from "./CardBox.vue?vue&type=template&id=505702c2&scoped=true&"
import script from "./CardBox.vue?vue&type=script&lang=js&"
export * from "./CardBox.vue?vue&type=script&lang=js&"
import style0 from "./CardBox.vue?vue&type=style&index=0&id=505702c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505702c2",
  null
  
)

export default component.exports